import { Button } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import css from './CollectionSet.module.scss';
import List from './List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ProductSetWithoutTitle = function ProductSetWithoutTitle(_ref) {
  var cta = _ref.cta,
      description = _ref.description,
      displayEditorial = _ref.displayEditorial,
      displaySwatches = _ref.displaySwatches,
      isMobile = _ref.isMobile,
      products = _ref.products,
      subtitle = _ref.subtitle,
      url = _ref.url;
  return /*#__PURE__*/_jsxs("div", {
    className: css.content,
    children: [/*#__PURE__*/_jsxs("header", {
      className: cc([css.header, css.untitled]),
      children: [subtitle && /*#__PURE__*/_jsx("h3", {
        className: css.subtitle,
        children: subtitle
      }), description && /*#__PURE__*/_jsx("p", {
        className: css.description,
        children: description
      })]
    }), /*#__PURE__*/_jsx(List, {
      displayEditorial: displayEditorial,
      displaySwatches: displaySwatches,
      isMobile: isMobile,
      products: products
    }), cta && url && /*#__PURE__*/_jsx("div", {
      className: css.cta,
      children: /*#__PURE__*/_jsx(Button, {
        href: url,
        children: cta
      })
    })]
  });
};

ProductSetWithoutTitle.defaultProps = {
  description: '',
  subtitle: '',
  displayEditorial: false
};
ProductSetWithoutTitle.propTypes = {
  cta: PropTypes.string,
  description: PropTypes.string,
  displayEditorial: PropTypes.bool,
  displaySwatches: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  products: PropTypes.shape().isRequired,
  subtitle: PropTypes.string,
  url: PropTypes.string
};
export default ProductSetWithoutTitle;